import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorMessageInterceptor } from '@capturum/complete';

@Injectable({ providedIn: 'root' })
export class CustomErrorMessageInterceptor extends ErrorMessageInterceptor {
    public exceptionUrls(err: HttpErrorResponse): boolean {
        if (err.status === 422 && err.url?.includes('/transition-document/') && err.url?.endsWith('/answers')) {
            return false;
        }

        return super.exceptionUrls(err);
    }
}
